<template>
  <div class="app-wrapper" :class="classObj">
    <!-- ✅ Fixed Navbar -->
    <navbar class="navbar-fixed" />

    <!-- ✅ Below Navbar: Sidebar + Main -->
    <div class="layout-body">
      <sidebar class="sidebar-container" />
      <div class="main-container">
        <app-main />
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'LayoutPage',
  components: { Navbar, Sidebar, AppMain },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: this.device === 'mobile' && !this.sidebar.opened,
        mobile: this.device === 'mobile'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.app-wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: visible;
  background: #f5f6fa;
}

/* ✅ Navbar always fixed at top */
.navbar-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  color: #333;
  z-index: 1000;
  display: flex;
  align-items: center;
}

/* ✅ Body section always below navbar */
.layout-body {
  display: flex;
  width: 100%;
  height: calc(100vh - 60px);
  margin-top: 60px;
  position: relative;
  overflow: visible;
}

/* ✅ Sidebar default */
.sidebar-container {
  width: 220px;
  height: 100%;
  background: #fff;
  color: #333;
  border-right: 1px solid #e6e6e6;
  transition: transform 0.3s ease;
  z-index: 900;
  position: relative;
  margin-top: 60px;
  /* ensures below navbar */
}

/* ✅ Main content area */
.main-container {
  flex: 1;
  height: 100%;
  background: #f4f6f8;
  overflow-y: auto;
  padding: 20px;
}

.mobile .main-container {
  flex: 1;
  height: 100%;
  background: #f4f6f8;
  overflow-y: auto;
  padding: 20px;
}

/* ✅ Mobile layout */
.mobile .sidebar-container {
  position: fixed;
  margin-top: 10px;
  /* directly below navbar */
  left: 0;
  height: calc(100dvh - 60px);
  transform: translateX(-100%);
  z-index: 999;
  background: #fff;
  width: 220px;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch;
  /* iOS smooth scrolling */
  /* ← required for long menu */
  // box-shadow: 2px 0 8px rgba(0, 0, 0, 0.3);
}

.mobile:not(.hideSidebar) .sidebar-container {
  transform: translateX(0);
}

/* ✅ Dark overlay for mobile when sidebar is open */
.mobile:not(.hideSidebar)::after {
  content: '';
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 998;
}

/* ✅ Desktop always open sidebar */
@media (min-width: 1025px) {
  .sidebar-container {
    transform: none !important;
    position: relative;
    top: 20;
  }
}
</style>
